import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, CreditCard } from "lucide-react";
import { Link } from "@tanstack/react-router";

export const Route = createFileRoute("/(public)/stripe/return")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(8);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate({ to: "/dashboard" });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-emerald-50">
      <div className="text-center max-w-lg mx-auto px-4">
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>

        <h1 className="font-h1 text-green-600 mb-4 text-3xl">
          Configuration terminée ! ✅
        </h1>

        <p className="font-p text-muted-foreground mb-6 text-lg">
          Félicitations ! Votre compte Stripe a été configuré avec succès.
        </p>

        <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-green-200">
          <div className="flex items-center justify-center gap-2 mb-3">
            <CreditCard className="w-5 h-5 text-green-600" />
            <span className="font-semibold text-green-700">Compte prêt</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Vous pouvez maintenant recevoir des paiements pour vos services de
            chef. Vos clients pourront réserver vos services en toute sécurité.
          </p>
        </div>

        <p className="font-p text-muted-foreground mb-8">
          Redirection automatique vers votre dashboard dans {countdown} seconde
          {countdown > 1 ? "s" : ""}...
        </p>

        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/dashboard">Accéder à mon tableau de bord</Link>
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/">Retour à l'accueil</Link>
          </Button>
        </div>

        <p className="text-xs text-muted-foreground mt-6">
          Votre compte est maintenant entièrement configuré pour recevoir des
          paiements.
        </p>
      </div>
    </div>
  );
}
